/* Mobile PDP gallery dot indicators (Norvo-style).
   Runs only on <=749px. Builds dots from .product__media-item count,
   syncs active dot to scroll position, and lets taps scroll the slider. */
(function () {
  'use strict';

  function buildDots() {
    if (window.matchMedia('(min-width: 750px)').matches) return;
    var galleries = document.querySelectorAll('.product__media-list');
    galleries.forEach(function (gallery) {
      if (gallery.dataset.cxDots === '1') return;
      var slides = gallery.querySelectorAll('.product__media-item');
      if (slides.length < 2) return;

      var wrapper = gallery.closest('slider-component') || gallery.parentElement;
      if (!wrapper) return;

      var dots = document.createElement('div');
      dots.className = 'cx-gallery-dots';
      dots.setAttribute('role', 'tablist');

      slides.forEach(function (_slide, idx) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cx-gallery-dot' + (idx === 0 ? ' is-active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Afbeelding ' + (idx + 1) + ' van ' + slides.length);
        dot.addEventListener('click', function () {
          slides[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dots.appendChild(dot);
      });

      wrapper.insertAdjacentElement('afterend', dots);

      var syncTick = null;
      gallery.addEventListener('scroll', function () {
        if (syncTick) cancelAnimationFrame(syncTick);
        syncTick = requestAnimationFrame(function () {
          var slideW = slides[0].getBoundingClientRect().width || 1;
          var idx = Math.round(gallery.scrollLeft / slideW);
          if (idx < 0) idx = 0;
          if (idx > slides.length - 1) idx = slides.length - 1;
          var children = dots.children;
          for (var i = 0; i < children.length; i++) {
            children[i].classList.toggle('is-active', i === idx);
          }
        });
      }, { passive: true });

      gallery.dataset.cxDots = '1';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildDots);
  } else {
    buildDots();
  }
  // Re-run when variant change swaps DOM, or when section editor reloads
  document.addEventListener('shopify:section:load', buildDots);
})();
